module.exports = __webpack_public_path__ + "static/yav@2x-4c62ad00b5bfdc0713a2d4539f9751fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pricing/yav@2x.jpg
// module id = 935
// module chunks = 18116671869107 235176306749093